<template>
	<div>
		<section class="top-fixing">
			<section class="common-top container">
				<section class="top-info-wrap">
					<!-- 뒤로가가-->
					<div class="prev-wrap">
						<a @click="pageBefore()" class="prev"></a>
					</div>
					<!-- //뒤로가가-->
					<span class="title">문진표 선택</span>
				</section>
			</section>
		</section>

		<!-- 간격 조정용 -->
		<div class="space"></div>
		<!-- //간격 조정용 -->

		<section class="question-wrap">
			<!-- 좌-->
			<div class="left">
				<ul>
					<li class="active">
						<figure><img :src="require(`@/assets/images/${icon1}`)" alt="" /></figure>
						<span>국가검진</span>
					</li>
					<li>
						<figure><img :src="require(`@/assets/images/${icon1}`)" alt="" /></figure>
						<span>영유아검진</span>
					</li>
					<li>
						<figure><img :src="require(`@/assets/images/${icon1}`)" alt="" /></figure>
						<span>정신건강문진</span>
					</li>
					<li>
						<figure><img :src="require(`@/assets/images/${icon1}`)" alt="" /></figure>
						<span>병원문진</span>
					</li>
				</ul>
			</div>
			<!-- // 좌 -->

			<!-- 우 -->
			<div class="right">
				<div class="bundle">
					<!-- <h1>당일문진</h1> -->
					<p>CDR</p>
					<p>MMSE</p>
					<p>HAS</p>
					<p>HAMD</p>
					<p>GDS</p>
				</div>
				<div class="bundle">
					<!-- <h1>사전문진</h1> -->
					<p>PDSS</p>
					<p>PANSS</p>
					<p>BPRS</p>
					<p>ASRRS</p>
				</div>
			</div>
			<!-- // 우 -->
		</section>
	</div>
</template>

<script>
import $ from 'jquery';
export default {
	data() {
		return {
			icon1: 'ic_profile_edit.png'
		};
	},
	mounted() {
		$('.question-wrap .left ul li').click(function () {
			$('.question-wrap .left ul li').removeClass('active');
			$(this).addClass('active');
		});
	}
};
</script>

<style lang="scss" scoped>
.common-top .top-info-wrap {
	position: relative;

	.prev-wrap {
		position: absolute;
		top: 0.2em;
	}
}
.title {
	font-family: 'Noto Sans KR', sans-serif;
	font-size: 2rem;
	font-weight: 400;
	line-height: 3rem;
	color: #000;
	margin: 0 auto;
}
.common-top {
	padding-bottom: 30px;
}
.space {
	height: 81px;
}
.question-wrap {
	display: flex;
	min-height: calc(100vh - 81px);
	background: #f4f4f4;

	.left {
		width: 25%;
		padding: 30px 30px;

		ul {
			display: flex;
			flex-direction: column;
			width: 100%;

			li {
				width: 100%;
				margin-bottom: 20px;
				padding: 20px;
				text-align: center;
				background-color: #fff;
				border: 2px solid #fff;
				border-radius: 4px;

				figure {
					width: 80%;
					margin: 0 auto 10px;

					img {
						width: 100%;
					}
				}

				span {
					font-size: 1.5rem;
					font-weight: 600;
					color: #8d8d8d;
				}
			}

			li.active {
				border-color: #ff655a;

				span {
					color: #ff655a;
				}
			}
		}
	}
	.right {
		flex-grow: 1;
		padding: 30px 30px;
		background-color: #fff;

		.bundle {
			&:nth-child(1) {
				h1 {
					margin-top: 0;
				}
			}
			h1 {
				margin-top: 2em;
				font-size: 1.6rem;
			}
			p {
				margin: 0.75em 0;
				padding: 1em;
				text-align: center;
				font-size: 1.5rem;
				background-color: #efefef;
				border-radius: 10px;
			}
		}
	}
}
</style>

<style scoped>
li {
	box-shadow: 0 1px 3px rgb(199 199 199 / 12%), 0 1px 2px rgb(142 142 142 / 24%);
}
</style>
